// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  apiServerUrl: window["env"]["apiServerUrl"] || "http://localhost:3003/",
  apiVersion: window["env"]["apiVersion"] || "api/v1/",
  fileServerUrl: window["env"]["fileServerUrl"] || "http://localhost:5005/",
  fileVersion: window["env"]["fileVersion"] || "file/v1/",
  defaultLanguage: window["env"]["defaultLanguage"] || "en",
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
